import { render, staticRenderFns } from "./_customers.vue?vue&type=template&id=01eaaab9&scoped=true&"
import script from "./_customers.vue?vue&type=script&lang=js&"
export * from "./_customers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01eaaab9",
  null
  
)

export default component.exports